import { Observable, of } from 'rxjs';

import { ParcelService } from '../services/parcel.service';
import { Parcel, ToolStatus } from '../models/parcel.model';
import { showErrorMessage } from './utils';

const ignoredProperties = new Set<string>(['id', 'completed', 'order', 'parcel', 'createdAt', 'updatedAt']);

export function prepareBatchSave(modelOrderItem: any, batchOrderItems: any[], fieldsToCopy: Object): any[] {
  const propertyNames = Object.getOwnPropertyNames(modelOrderItem);
  batchOrderItems.forEach((batchOrderItem: any) => {
    // fill
    for (const propertyName of propertyNames) {
      if (ignoredProperties.has(propertyName)) {
        continue;
      }
      if ((<any>fieldsToCopy)[propertyName]) {
        // cb cochée
        (<any>batchOrderItem)[propertyName] = (<any>modelOrderItem)[propertyName];
      }
    }
  });
  return batchOrderItems;
}

export function getBatchOrderItems(
  parcelService: ParcelService,
  oadService: any,
  parcelIds: number[],
  component: any,
  toolStatusCode: string,
  newOrderItem: Function,
  newParcel: Function,
  route: Array<string>,
  orderItemCallback: Function = null,
) {
  if (!parcelIds || parcelIds.length === 0) {
    return;
  }

  parcelService.getParcelStatuses(parcelIds).subscribe((x) => {
    const orderItemIds: number[] = [];
    const editableParcelIds: number[] = [];
    const editableOrderItems: any[] = [];
    for (const p of x) {
      const results: Array<string> = [];
      if (p.toolStatuses && (<any>p.toolStatuses)[toolStatusCode]) {
        const toolStatus = <ToolStatus>(<any>p.toolStatuses)[toolStatusCode];
        if (toolStatus.canBeEdited) {
          editableParcelIds.push(p.parcelId);
          if (toolStatus.orderItemId) {
            // déjà un orderItemId
            orderItemIds.push(toolStatus.orderItemId);
          } else {
            // nouveau
            const editableOrderItem = newOrderItem();
            editableOrderItem.parcel = newParcel();
            editableOrderItem.parcel.id = p.parcelId;
            editableOrderItems.push(editableOrderItem);
          }
        }
      }
    }

    if (editableParcelIds.length === 0) {
      showErrorMessage(component.modal, 'Aucune des parcelles sélectionnées ne peut être éditée.').then((r: any) => {
        component.router.navigate(['/orders'].concat(route).concat(['parcels']));
      });
    } else {
      let obs1: Observable<any[]>;
      if (orderItemIds.length > 0) {
        obs1 = oadService.getOrderItems(orderItemIds, null, null);
      } else {
        obs1 = of([]);
      }
      obs1.subscribe(
        (data: any) => {
          const orderItems: any[] = data;
          component.batchOrderItems = editableOrderItems.concat(orderItems);
          // placeholder pour l'édition en batch => quand save, données des
          // order Items seront recopiées depuis cet objet
          const editableOrderItem = newOrderItem();
          // au moins 1 orderItem rempli
          const propertyNames = Object.getOwnPropertyNames(editableOrderItem);
          component.cbBatchEdit = {};
          for (const propertyName of propertyNames) {
            if (ignoredProperties.has(propertyName)) {
              continue;
            }
            let isChecked = false;
            if (orderItems.length > 0) {
              let value: any = undefined;
              for (const orderItem of orderItems) {
                const propertyValue: any = (<any>orderItem)[propertyName];
                if (value === undefined) {
                  // première valeure
                  isChecked = true;
                  if (propertyValue && propertyValue.hasOwnProperty('id')) {
                    // on prend cette valeur de liste pour l'instant
                    // deep copy
                    value = {};
                    Object.assign(value, propertyValue);
                  } else if (propertyValue !== undefined) {
                    // on prend la valeur du champ pour l'instant
                    value = propertyValue;
                  } else {
                    // on laisse le champ vide mais on distingue du cas non initialisé
                    // un champ vide peut êtte valide
                    value = null;
                  }
                } else {
                  if ((value && value.hasOwnProperty('id')) || (propertyValue && propertyValue.hasOwnProperty('id'))) {
                    // list item
                    if (!value || !propertyValue || value.id !== propertyValue.id) {
                      // plusieurs valeurs différentes ou un est vide mais pas l'autre: on laisse vide + pas sélectionné
                      value = { id: null };
                      isChecked = false;
                      break;
                    }
                  } else {
                    // choix libre
                    if (
                      (value !== null &&
                        !(
                          value === propertyValue ||
                          // special pour les dates où === sera false
                          (value instanceof Date &&
                            propertyValue &&
                            propertyValue instanceof Date &&
                            value.getTime() === propertyValue.getTime())
                        )) ||
                      (value === null && !(propertyValue === null || propertyValue === undefined))
                    ) {
                      // plusieurs valeurs différentes pour property (y compris vide)
                      // => on laisse vide + pas sélectionné
                      value = null;
                      isChecked = false;
                      break;
                    }
                  }
                }
              }
              (<any>editableOrderItem)[propertyName] = value;
            } else {
              // aucun order item rempli => le champ est vide mais sélectionné par
              // défaut
              (<any>editableOrderItem)[propertyName] = null;
              isChecked = true;
            }

            (<any>component.cbBatchEdit)[propertyName] = isChecked;
          }

          component.orderItem = editableOrderItem;
          component.prepareOrderItem();
          if (orderItemCallback) {
            orderItemCallback(component.orderItem);
          }
        },
        (e) => component.handleGetError(e),
      );
    }
  });
}
